<template lang="pug">
    .play-box
        template(v-if='!isLoading')
                game-header(
                    v-if="!isBattle"
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='gameStarted && !gameFinished')
                    .play-box__example
                        .play-box__overflow-container
                            .play-box__field
                                draggable.left-side(v-model="examples" v-if="gameView === 'words'" v-bind="dragOptions" :move="handleMoveLeft" @end="onDragEndLeft")
                                    .play-box-word(v-for="(word) in examples" :style="calculateStyleForElement")
                                        | {{ word.word }}
                                draggable.left-side(v-model="examples" v-if="gameView === 'pictures'" v-bind="dragOptions" :move="handleMoveLeft" @end="onDragEndLeft")
                                    .play-box-image(v-for="(word) in examples")
                                        img(:src="word.imageSrc | apiFile")
                                .center
                                draggable.right-side(v-model="userAnswers" v-if="gameView === 'words'" v-bind="dragOptions" :move="handleMoveRight" @end="onDragEndRight")
                                    .play-box-word(v-for="(word) in userAnswers" :style="calculateStyleForElement")
                                        | {{ word.word }}
                                draggable.right-side(v-model="userAnswers" v-if="gameView === 'pictures'" v-bind="dragOptions" :move="handleMoveRight" @end="onDragEndRight")
                                    .play-box-image(v-for="(word) in userAnswers")
                                        img(v-if="word.imageSrc" :src="word.imageSrc | apiFile")
                                        div(v-else)
                            cs-button.play-box__next-example-button(
                                    v-if="!isCorrectAnswerGiven",
                                    @click="processReply()",
                                    pattern="primary-outline",
                                    color="blue"
                                    :disabled="isDisabledProcessReplyBtn"
                                )  {{ $i18n.t('trainer.trainer_gamePlayBox_checkAnswer') }}
                            cs-button.play-box__next-example-button(
                                    v-if="isCorrectAnswerGiven",
                                    @click="nextExample",
                                    pattern="primary-outline",
                                    color="blue"
                                )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                .game-info__block(v-if="gameStarted && !gameFinished")
                        game-info(
                            :score="{left: answers.good, right: answers.bad}"
                            :time="getTime"
                            :slug="type"
                            :parameters="parameters"
                            :game-allows-tips="true"    
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            result-image.play-box__image(:status="gameResult")
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                br
                                | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import AlphabetGameItems from '@/api/games/alphabetGameItems';
    import draggable from 'vuedraggable';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import { cloneDeep } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA() {
        return {
            examples: null,
            examplesCopy: null,
            userAnswers: [],
            userAnswersCopy: [],
            correctAnswers: [],
            clientWidth: 0,
            currentLevel: 1,
            answers: { good: 0, bad: 0 },
            isCorrectAnswerGiven: false,
            wordsForCurrentLevel: null,
            movingIndexLeft: null,
            futureIndexLeft: null,
            movingIndexRight: null,
            movingItem: null,
            onMoveRelatedContextLeft: null,
            onMoveRelatedContextRight: null,
            isSecondProcessReply: false,
            relatedClassRight: null,
            isDisabledProcessReplyBtn: true,
        };
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, Battle, olympiadRussianLanguageAnswerTimerMixin],
        created() {
            window.addEventListener('resize', this.getClientWidth);
        },
        data() {
            return DEFAULT_DATA();
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        computed: {
            calculateStyleForElement() {
                return { fontSize: 9 / this.parameters.amountOfWords + 'em' };
            },
            dragOptions() {
                if (this.gameView === 'words') {
                    return {
                        animation: 0,
                        group: 'description',
                        disabled: false,
                        ghostClass: 'ghost',
                    };
                } else {
                    return {
                        animation: 0,
                        group: 'items',
                    };
                }
            },
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples ? 1 : 0;
            },
            pointer() {
                if (this.parameters.difficult === 'byFirstSecondLetter') return 2;
                if (this.parameters.difficult === 'byFirstSecondThirdLetter') return 3;
                return 1;
            },
            gameView() {
                return this.parameters.theme;
            },
        },
        updated() {
            if (this.userAnswers.every(obj => obj.word !== '')) {
                this.isDisabledProcessReplyBtn = this.userAnswers.length !== this.parameters.amountOfWords;
            } else {
                this.isDisabledProcessReplyBtn = true;
            }
        },
        methods: {
            handleKeyPress(event) {
                if (event.key === 'Enter' && !this.gameFinished) {
                    if (!this.isDisabledProcessReplyBtn && !this.isCorrectAnswerGiven) {
                        return this.processReply();
                    };
                    if (this.isCorrectAnswerGiven) {
                        return this.nextExample();
                    };
                }
            },
            handleMoveRight(event) {
                if (event.draggedContext.element.isCorrect || event.draggedContext.element.word === '') return false;
                if (this.isSecondProcessReply) {
                    this.relatedClassRight = event.relatedContext.component.$el._prevClass;
                    if (this.relatedClassRight === 'right-side') return false;
                    this.onMoveRelatedContextRight = event.relatedContext;
                    this.userAnswersCopy = cloneDeep(this.userAnswers);
                    this.movingIndexRight = event.draggedContext.index;
                }
            },
            onDragEndRight() {
                if (
                    this.isSecondProcessReply &&
                    this.relatedClassRight === 'left-side' &&
                    (this.onMoveRelatedContextRight.element === undefined ||
                        this.onMoveRelatedContextRight.element.word !== '')
                ) {
                    this.userAnswersCopy.splice(this.movingIndexRight, 1, { word: '', order: null, fixed: false });
                    this.$set(this, 'userAnswers', this.userAnswersCopy);
                    this.relatedClassRight = '';
                }
            },
            handleMoveLeft(event) {
                if (this.isSecondProcessReply) {
                    const { index, element } = event.draggedContext;
                    this.onMoveRelatedContextLeft = event.relatedContext.element;
                    this.movingIndexLeft = index;
                    this.futureIndexLeft = event.relatedContext.index;
                    this.movingItem = element;
                    return false; // disable sort
                }
            },
            onDragEndLeft() {
                if (this.isSecondProcessReply && this.onMoveRelatedContextLeft?.word === '') {
                    this.userAnswers[this.futureIndexLeft] = this.movingItem;
                    this.examples.splice(this.movingIndexLeft, 1);
                    this.onMoveRelatedContextLeft = null;
                }
            },
            processReply(finishExample = false) {
                this.isSecondProcessReply = true;
                let correctAnswersArray = [];
                this.userAnswers.forEach(obj => {
                    correctAnswersArray.push(obj.word.slice(0, this.pointer));
                });
                correctAnswersArray = [...correctAnswersArray].sort((a, b) => a.localeCompare(b));
                this.userAnswers.forEach((obj, index) => {
                    if (correctAnswersArray[index] === obj.word.slice(0, this.pointer)) {
                        !obj.isCorrect && this.answers.good++;
                        obj.isCorrect = true;
                    } else {
                        this.answers.bad++;
                        this.$set(this.userAnswers, index, { word: '', order: obj.order, fixed: false });
                        this.examples.push({ ...obj, order: null });
                    }
                });
                this.isCorrectAnswerGiven = this.userAnswers.every(obj => {
                    return obj.isCorrect === true;
                });
                if (finishExample || this.isOlympiad || this.isBattle) {
                    this.nextExample();
                }
            },
            nextExample() {
                this.stopAnswerTimer();
                this.currentLevel++;
                if (!this.isInfiniteAmountOfExamples && this.currentLevel > this.parameters.amountOfExamples) {
                    return this.finishGame();
                }
                this.isLoading = true;
                this.isSecondProcessReply = false;
                this.isCorrectAnswerGiven = false;
                this.userAnswers = [];
                this.getGameItems();
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            getGameItems() {
                let subgroup = Math.floor(Math.random() * 5) + 1;
                AlphabetGameItems.getItemsByRequest({
                    isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                    amountOfWords: this.parameters.amountOfWords,
                    difficultWords: this.parameters.difficultWords,
                    type: this.parameters.theme,
                    group: this.parameters.difficult,
                    subgroup,
                })
                    .then(data => {
                        this.examples = data.map((object, index) => ({
                            ...object,
                            order: index + 1,
                            fixed: false,
                            isCorrect: false,
                        }));
                        this.examplesCopy = cloneDeep(this.examples);
                        this.startGame();
                        this.registerSounds();
                        this.isLoading = false;
                    })
                    .catch(e => this.showErrorMessage(e));
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.getGameItems();
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.currentLevel - 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.handleKeyPress);
            window.removeEventListener('resize', this.getClientWidth);
        },
        components: {
            CsLoader,
            CsButton,
            draggable,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/playbox.scss';

    .play-box {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        width: 100%;
        align-items: center;
        flex-direction: column-reverse;
        @include media($lg) {
            align-items: stretch;
            flex-direction: row;
        }
    }

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__overflow-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        font-weight: bold;
        display: grid;
        grid-template-columns: 1fr auto 1fr;
    }

    .play-box__words-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__word {
        padding: 0 8px;
        margin: 0 10px 3px 0;
        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__word--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__before-start-game-header {
        flex-direction: column;
    }

    .play-box__task {
        align-self: center;
    }

    .play-box__title {
        margin-bottom: 20px;
        text-align: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
        justify-content: center;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__answers-field {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

    .play-box__answer {
        margin: 10px;
        padding: 15px;
        border: 3px solid $hsl-color-gray-74;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .play-box__next-example-button {
        margin-top: 15px;
    }

    .divide-it-right__answer-buttom {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .divide-it-right__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .play-box-word {
        border: 2px solid black;
        margin: 10px;
        cursor: pointer;
        min-height: 1.1em;
        @include media($lg) {
            margin: 15px;
        }
        @include media($xlg) {
            margin: 15px 35px;
        }
    }

    .play-box-image {
        width: 45px;
        height: 45px;
        margin: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        @include media($sm) {
            width: 60px;
            height: 60px;
        }
        @include media($md) {
            width: 90px;
            height: 90px;
        }
        @include media($lg) {
            margin: 15px;
            width: 110px;
            height: 110px;
        }
        @include media($xlg) {
            width: calc(20vh - 85px);
            height: calc(20vh - 85px);
        }
    }

    .left-side {
        font-size: 17px;
        @include media($sm) {
            font-size: 20px;
        }
        @include media($md) {
            font-size: 26px;
        }
        @include media($lg) {
            font-size: 30px;
        }
        @include media($xlg) {
            font-size: 35px;
        }
        @include media($xlg) {
            font-size: 40px;
        }
    }

    .right-side {
        font-size: 17px;
        @include media($sm) {
            font-size: 20px;
        }
        @include media($md) {
            font-size: 26px;
        }
        @include media($lg) {
            font-size: 30px;
        }
        @include media($xlg) {
            font-size: 35px;
        }
        @include media($xlg) {
            font-size: 40px;
        }
    }

    .center {
        height: auto;
        width: 4px;
        background-color: $hsl-color-green-58;
        border-radius: 2px;
    }
</style>
